import { defineStore } from "pinia";
import Vue from "vue";
import moment from "moment";
import { of, concatMap, timer, catchError } from 'rxjs';
function runWithDelayAfterComplete(test) {
  test().pipe(
    catchError(error => {
      return of({ error: true, message: error.message });
    }),
    concatMap(result => {
      return timer(10000);
    }),
    concatMap(() => runWithDelayAfterComplete(test))
  ).subscribe({
    error: err => true
  });
}
export const useUserStore = defineStore("user", {
  state: () => ({
    token: null,
    profile: null,
    enums: null,
    sidebar: true,
    employee_edit: false,
    borrow_status_my: false,
    borrow_status_management: false

  }),
  getters: {
    userToken: (state) => {
      try {
        var tk = null;
        if (state.token) {
          tk = state.token;
        } else {
          var ts = Vue.ls.get("token", null, String);
          if (ts) {
            tk = JSON.parse(ts);
            state.token = tk;
          }
        }
        if (tk) {
          var now = moment();
          var issue = moment(tk.IssueDate || "1900-01-01");
          var d = now.diff(issue, "minutes");
          if (d > (tk.ExpiredIn || 720)) {
            tk = null;
            Vue.ls.remove("token");
            state.token = null;
            return null;
          }
          return tk;
        }
      } catch (err) { }
      return null;
    },
  },
  actions: {
    isEmployeeEdit(account_id) {
      if (!this.profile) return false;
      if (!this.employee_edit) return false;
      if (this.profile.id == account_id) return true;
      if (this.isUserInRoles([1, 6])) return true;
      return false;
    },
    isUserInRoles(arr) {
      if (!this.profile) return false;
      for (let i in arr) {
        if (this.profile.role == arr[i]) {
          return true;
        }
      }
      return false;
    },
    login(app, vm) {
      Vue.hc
        .req()
        .post("accounts/login", vm, (x) => {
          if (x.Success) {
            Vue.ls.set("token", JSON.stringify(x.Data));
            this.$patch({
              token: x.Data,
            });
          }
        })
        .get("accounts/profile", (x) => {
          this.$patch({ profile: x.Data });
        })
        .get(`settings/enums`, (x) => {
          this.$patch({ enums: x.Data });
        })
        .go({
          lock: true,
          toastError: false,
          toastSuccess: "登陆成功",
        })
        .subscribe(
          (x) => {
            if (this.isUserInRoles([1, 2, 5, 6, 7, 8])) {
              app.$router.replace("/");
            } else {
              app.$router.replace("/projects");
            }

          },
          (x) => {
            app.$ns.cast("snack", {
              text: "用户名或密码错误",
              color: "error",
            });
          }
        );
    },

    logout() {
      Vue.ls.remove("token");
      this.profile = null;
      this.token = null;
    },
    getUserProfile() {
      return Vue.hc
        .req()
        .get("accounts/profile", (x) => this.$patch({ profile: x.Data }))
        .get(`settings/enums`, (x) => {
          this.$patch({ enums: x.Data });
        })
        .go({
          lock: true,
          toastError: false,
          toastSuccess: "",
        });
    },
    getBorrowStatus() {
      var self = this;
      Vue.hc.req()
        .get("borrow/requests/borrowstatus", (x) => {
          self.borrow_status_management = x.Data.management;
          self.borrow_status_my = x.Data.my;
        })
        .go({
          lock: false,
          toastError: false,
          toastSuccess: "",
        }).subscribe(
          (x) => {
          },
          (x) => {
          }
        );
    },
    monitorBorrowStatus() {
      var self = this;
      function _getBorrowStatus() {
        return Vue.hc.req()
          .get("borrow/requests/borrowstatus", (x) => {
            self.borrow_status_management = x.Data.management;
            self.borrow_status_my = x.Data.my;
          })
          .go({
            lock: false,
            toastError: false,
            toastSuccess: "",
          }).pipe(
            catchError(error => {
              return of({});
            }));
      }
      runWithDelayAfterComplete(_getBorrowStatus)

    }
  },
});
